import { createApp } from 'vue'
import App from './App.vue'

// Application identification console log
console.log(`
🤝 BANJINO'S B2B WHOLESALE PORTAL
📍 Domain: partners.banjinos.com  
📂 Frontend: /frontend-b2b (B2B)
🎯 Purpose: Wholesale ordering, credit management, B2B dashboard
🚀 Starting application...
`);

// Note: axios configuration is handled in services/axios.js

// Vuetify
import vuetify from './plugins/vuetify'

// Import Master Brand System (SCSS) - MUST be after Vuetify to override
import './assets/scss/main.scss'

// Material Design Icons
import '@mdi/font/css/materialdesignicons.css'

// Pinia
import { createPinia } from 'pinia'

// Router
import router from './router'

const pinia = createPinia()

// Note: axios interceptors are handled in services/axios.js to avoid conflicts

// Note: Auth header setup is handled in services/axios.js

createApp(App)
  .use(vuetify)
  .use(pinia)
  .use(router)
  .mount('#app')
